<template>
  <div class="checkdevicepage_div">
    <van-loading class="checkdevicepage_loading">加载中...</van-loading>
    <div class="checkdevicepage_showdeviceiddiv" @dblclick="showDeviceId"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    sessionStorage.removeItem("autoJumpList");
    if (this.$route.query.equipmentId) {
      sessionStorage.setItem("equipmentId", this.$route.query.equipmentId);
      this.getDeviceInfo(this.$route.query.equipmentId);
    } else {
      this.getEquipmentId();
    }
  },
  methods: {
    getEquipmentId() {
      let _this = this;
      if ($deviceId && $deviceId.getDeviceSerialId) {
        $deviceId.getDeviceSerialId(
          function (res) {
            let equipmentId = res || "";
            sessionStorage.setItem("equipmentId", equipmentId);
            _this.getDeviceInfo(equipmentId);
          },
          function (error) {
            dsf.layer.message("获取设备信息失败", false);
          }
        );
      }
    },
    getDeviceInfo(equipmentId) {
      let _this = this;
      this.$http
        .get(
          "/teas/screen/getDeviceSetting",
          {
            equipmentId: equipmentId || "",
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            let tempData = data || {};
            sessionStorage.setItem("deviceInfo", JSON.stringify(tempData));
            _this.checkJumpPage(tempData);
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    checkJumpPage(data) {
      let urlString = "";
      if (data.typeValue && data.typeValue == 1) {
        urlString = "/mobile/bootScreen/transverse/";
      } else {
        urlString = "/mobile/bootScreen/longitudinal/";
      }
      if (
        data.verticalReleaseTypeList &&
        data.verticalReleaseTypeList.length > 0
      ) {
        let tempItem = data.verticalReleaseTypeList[0] || {};
        let tempType = tempItem.moduleId || "0";
        switch (parseInt(tempType)) {
          case 1: {
            urlString = urlString + "schoolIntroduction";
            break;
          }
          case 2: {
            urlString = urlString + "campusDynamic";
            break;
          }
          case 3: {
            urlString = urlString + "announcements";
            break;
          }
          case 4: {
            if (data.typeValue && data.typeValue == 1) {
              urlString = urlString + "curriculum";
            } else {
              urlString = urlString + "curriculumClasses";
            }
            break;
          }
          case 5: {
            if (data.typeValue && data.typeValue == 1) {
              urlString = urlString + "classroomArrangement";
            } else {
              urlString = urlString + "courseArrangement";
            }
            break;
          }
          default:
            break;
        }
        setTimeout(() => {
          this.$router.replace({
            path: urlString,
          });
        }, 1000);
      }
    },
    showDeviceId() {
      if ($deviceId && $deviceId.getDeviceSerialId) {
        $deviceId.getDeviceSerialId(
          function (res) {
            let equipmentId = res || "";
            dsf.layer.alert({
              title: "设备ID",
              message: equipmentId,
              showClose: false,
            });
          },
          function (error) {
            dsf.layer.message("获取设备信息失败", false);
          }
        );
      }
    },
  },
};
</script>

<style>
</style>